import categoriesData from './categories.json';
import animeQuestions from './packs/anime.json';
import cinemaQuestions from './packs/cinema.json';
import generalQuestions from './packs/general.json';
import geographyQuestions from './packs/geography.json';
import historyQuestions from './packs/history.json';
import literatureQuestions from './packs/literature.json';
import musicQuestions from './packs/music.json';
import mythologyQuestions from './packs/mythology.json';
import popCultureQuestions from './packs/pop-culture.json';
import scienceNatureQuestions from './packs/science-nature.json';
import sportsGamesQuestions from './packs/sports-games.json';
import videoGamesQuestions from './packs/video-games.json';

export const triviaQuestionPacks = [
  historyQuestions,
  geographyQuestions,
  mythologyQuestions,
  literatureQuestions,
  scienceNatureQuestions,
  generalQuestions,
  popCultureQuestions,
  animeQuestions,
  videoGamesQuestions,
  cinemaQuestions,
  musicQuestions,
  sportsGamesQuestions,
];

export const triviaQuestionData = {
  version: categoriesData.version,
  categories: categoriesData.categories,
  questions: triviaQuestionPacks.flatMap((pack) => pack.questions),
};
